import { IDispatch } from "../context/authContext";

export function storeReducer(state: any, action: IDispatch) {
    switch (action.type) {
        case "set_store":
            return { ...state, ...action.payload };
    }
    throw Error("Action não encontrada: " + action.type);
}
